export const ModifyPenaltyOutcome = {
  name: "modify-penalty-outcome",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.penalty.success",
  showOn: [{ state: "editState", value: "penalty-outcome", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "penalty-change-to-made",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [
        {
          state: "event.subType",
          value: "made",
          operator: "is",
          event: "main",
        },
      ],
      options: {
        layout: "description-text",
        text: "penaltyStroke.change.to.missed",
      },
      actionGroups: [],
    },
    {
      name: "penalty-change-to-made",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [
        {
          state: "event.subType",
          value: "missed",
          operator: "is",
          event: "main",
        },
      ],
      options: {
        layout: "description-text",
        text: "penaltyStroke.change.to.made",
      },
      actionGroups: [],
    },
    {
      name: "confirm-panel",
      component: "SubPanel",
      layout: "sub-panel",
      mode: "visible",
      text: null,
      showOn: [true],
      children: [
        {
          name: "ok-button",
          component: "TypeButton",
          layout: "match-button action",
          mode: "enable",
          text: "ok",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                {
                  action: "switchValues",
                  value: {
                    eventType: "penaltyStroke",
                    property: "subType",
                    values: ["made", "missed"],
                  },
                  type: "main",
                },
                {
                  action: "switchValues",
                  value: {
                    eventType: "penaltyStroke",
                    property: "success",
                    values: [true, false],
                  },
                  type: "main",
                },
                {
                  action: "nextState",
                  value: null,
                  type: "editState",
                },
              ],
              conditions: [],
            },
          ],
        },
      ],
    },
  ],
};
